import { useState, useMemo, useCallback, memo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import 'swiper/scss';
import 'swiper/scss/pagination';
import EcoSpace from 'eco-design/base/eco-space';
import EcoImg from 'eco-design/base/eco-img';

import { productType } from '@elem/compPage/delta-3-series/config/pageConfig';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';

function SectionB() {
    const { t } = useLang('theProduct.SectionB');
    const [active, setActive] = useState(0);

    const cards = useMemo(
        () => [
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1761548409657/sectionb_1.jpg',
                imgh5: 'https://websiteoss.ecoflow.com/upload/image/1761556105137/sectionb_1_h5.jpg',
                title: t('card1_title'),
                desc: t('card1_desc'),
                id: productType.D3U,
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1761548409986/sectionb_2.jpg',
                imgh5: 'https://websiteoss.ecoflow.com/upload/image/1761556064660/sectionb_2_h5.jpg',
                title: t('card2_title'),
                desc: t('card2_desc'),
                id: productType.D3M,
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1761548409761/sectionb_3.jpg',
                imgh5: 'https://websiteoss.ecoflow.com/upload/image/1761556064366/sectionb_3_h5.jpg',
                title: t('card3_title'),
                desc: t('card3_desc'),
                id: productType.D3C,
            },
        ],
        [t],
    );

    const handleMouseEnter = useCallback((index: number) => {
        setActive(index);
    }, []);

    return (
        <div className={`${styles.SectionB} eco-content show GtmModuleData-section`} id="Covered" data-section-id={'on-the-road-SectionB'}>
            <EcoSpace />
            <div className="text-box">
                {/* <p className="text-desc">{t('sub_desc')}</p> */}
                <p className="text-title">{t('title')}</p>
                {/* <p className="text-sub-title">{t('sub_title')}</p> */}
            </div>

            {/* PC 端：原有的 flex 布局 */}
            <ul className="card-box card-box-pc">
                {cards?.map((card, index: number) => (
                    <li
                        className={`card ${index === active ? 'active' : ''}`}
                        key={index}
                        onMouseEnter={() => handleMouseEnter(index)}
                        style={{ animationDelay: `${200 * (index + 2)}ms` }}
                    >
                        <div className="card-img">
                            <EcoImg pc={card.img} h5={card.imgh5} isOpenLazy />
                        </div>
                        <div className="card-text">
                            <div>
                                <p className="card-title">{card.title}</p>
                                <p className="card-desc">{card.desc}</p>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>

            {/* Pad/H5 端：Swiper 滑动 */}
            <div className="card-box-mobile">
                <Swiper
                    modules={[Pagination]}
                    spaceBetween={16}
                    slidesPerView={1.1}
                    // centeredSlides={false}
                    pagination={{
                        clickable: true,
                        el: '.section-b-swiper-pagination',
                    }}
                    className="section-b-swiper"
                >
                    {cards?.map((card, index: number) => (
                        <SwiperSlide key={index}>
                            <div className="card-mobile">
                                <div className="card-img">
                                    <EcoImg pc={card.img} h5={card.imgh5} isOpenLazy />
                                </div>
                                <div className="card-text">
                                    <p className="card-title">{card.title}</p>
                                    <p className="card-desc">{card.desc}</p>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div className="section-b-swiper-pagination"></div>
            </div>

            {/* <div className="bottom-text-box">
                <p className="bottom-text-title">{t('sub_title')}</p>
            </div> */}
        </div>
    );
}

export default memo(SectionB);
